<template>
    <div class="my-connections">
        <common-tabs :tabs="tabs" :activeTab="tabs[0].name" @tab-click="tabChange($event)">
            <template v-slot:physicians>
                <common-loader :isProcessing="isLoading"></common-loader>
                <my-connections-list
                    v-if="!isLoading"
                    ref="physicianConnectionList"
                    :connections="physicianConnections"
                    :totalCount="totalCount"
                    :connectionDirection="physicianFilter.connectionDirection"
                    :orderBy="physicianFilter.orderBy"
                    :isPhysicianTab="showTabPhysicians"
                    @filter-changed="physicianFilterChanged"
                    @load-more="physicianLoadNextPage"
                    @reload-users="fetchData(false)"
                ></my-connections-list>
            </template>
            <template v-slot:providers>
                <common-loader :isProcessing="isLoading"></common-loader>
                <my-connections-list
                    v-if="!isLoading"
                    ref="ancillaryConnectionList"
                    :connections="ancillaryConnections"
                    :totalCount="totalCount"
                    :connectionDirection="ancillaryFilter.connectionDirection"
                    :orderBy="ancillaryFilter.orderBy"
                    :isPhysicianTab="showTabPhysicians"
                    @filter-changed="ancillaryFilterChanged"
                    @load-more="ancillaryLoadNextPage"
                    @reload-users="fetchData(false)"
                ></my-connections-list>
            </template>
        </common-tabs>
    </div>
</template>

<script>
    import MyConnectionsList from './MyConnectionsList'
    import UsersAPI from 'api/UsersAPI'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: {
            MyConnectionsList,
        },
        data() {
            return {
                pageSize: 0,
                showTabPhysicians: true,
                physicianConnections: [],
                ancillaryConnections: [],
                physicianFilter: {
                    connectionDirection: 'All',
                    limit: this.pageSize,
                    offset: 0,
                    orderBy: 'DateCreatedDESC',
                },
                ancillaryFilter: {
                    connectionDirection: 'All',
                    limit: this.pageSize,
                    offset: 0,
                    orderBy: 'DateCreatedDESC',
                },
                totalCount: 0,
                isLoading: false,
            }
        },
        computed: {
            tabs() {
                const tabs = [
                    {
                        name: 'physicians',
                        displayName: this.$t('pages.network.connections.tabs.physicians'),
                        icon: 'member-transparent',
                    },
                ]

                if (!this.$auth.isPracticeAncillary()) {
                    tabs.push({
                        name: 'providers',
                        displayName: this.$t('pages.network.connections.tabs.providers'),
                        icon: 'colleague-transparent',
                    })
                }

                return tabs
            },
        },

        methods: {
            tabChange(tabName) {
                if (tabName === this.tabs[0].name) {
                    this.physiciansTabClicked()
                } else {
                    this.ancillaryTabClicked()
                }
            },
            physiciansTabClicked() {
                this.isLoading = true

                this.showTabPhysicians = true
                this.physicianFilter.offset = 0
                this.$router.push({
                    ...this.$route,
                    query: { ...this.$route.query, status: 'all', practiceType: PracticeTypeEnum.PHYSICIAN },
                })
                this.fetchData().then(() => this.$refs.physicianConnectionList.resetConnectionListFilter())
            },
            ancillaryTabClicked() {
                this.isLoading = true

                this.showTabPhysicians = false
                this.ancillaryFilter.offset = 0
                this.$router.push({
                    ...this.$route,
                    query: { ...this.$route.query, status: 'all', practiceType: PracticeTypeEnum.ANCILLARY },
                })
                this.fetchData().then(() => {
                    this.$refs.ancillaryConnectionList.resetConnectionListFilter()
                })
            },
            physicianFilterChanged(filter) {
                this.isLoading = true
                this.physicianFilter.connectionDirection = filter.connectionDirection
                this.physicianFilter.orderBy = filter.orderBy

                this.physicianFilter.offset = 0

                this.fetchData(false)
            },
            ancillaryFilterChanged(filter) {
                this.isLoading = true
                this.ancillaryFilter.connectionDirection = filter.connectionDirection
                this.ancillaryFilter.orderBy = filter.orderBy

                this.ancillaryFilter.offset = 0

                this.fetchData(false)
            },
            fetchData(append) {
                const filterString = this.showTabPhysicians ? 'physicianFilter' : 'ancillaryFilter'
                this.changeIsSendingFlag(true)

                let request = {
                    practiceType: this.showTabPhysicians ? 'physician' : 'ancillary',
                    limit: this[filterString].limit,
                    offset: this[filterString].offset,
                }

                return UsersAPI.getMyConnectionsFromProviderTable(request, this.$auth.getActiveMember().id)
                    .then((conns) => {
                        this.totalCount = parseInt(conns._headers['x-total-count'])
                        this.setFetchedData(conns, append)
                        this.changeIsSendingFlag(false)
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },

            changeIsSendingFlag(value) {
                if (this.showTabPhysicians) {
                    if (this.$refs.physicianConnectionList) {
                        this.$refs.physicianConnectionList.isSending = value
                    }
                } else {
                    if (this.$refs.ancillaryConnectionList) {
                        this.$refs.ancillaryConnectionList.isSending = value
                    }
                }
            },

            setFetchedData(conns, append) {
                if (append) {
                    let collection = this.showTabPhysicians ? this.physicianConnections : this.ancillaryConnections
                    for (let i = 0; i < conns.length; ++i) {
                        collection.push(conns[i])
                    }
                } else {
                    if (this.showTabPhysicians) this.physicianConnections = conns
                    else this.ancillaryConnections = conns
                }
            },
            physicianLoadNextPage() {
                this.physicianFilter.offset = this.physicianFilter.offset + this.physicianFilter.limit
                this.fetchData(true)
            },
            ancillaryLoadNextPage() {
                this.ancillaryFilter.offset = this.ancillaryFilter.offset + this.ancillaryFilter.limit
                this.fetchData(true)
            },
        },

        beforeCreate() {
            this.pageSize = 6
        },

        created() {
            this.isLoading = true
            this.fetchData()
        },
    }
</script>
